import { sellerActionTypes } from '@Actions/sellerActions';

const SellerReducer = (state = {}, action) => {
  switch (action.type) {
  case `${sellerActionTypes.GET_CITY_STATE}_LOADING`: {
    const { cityStateLoading } = action;
    return {
      ...state,
      cityStateLoading,
    };
  }
  case `${sellerActionTypes.GET_CITY_STATE}_SUCCESS`: {
    const { pincodeCity, pincodeState } = action;
    return {
      ...state,
      pincodeCity,
      pincodeState,
      setCityStateError: null,
    };
  }
  case sellerActionTypes.CREATE_SELLER.LOADING: {
    const { createSellerLoading } = action;
    return {
      ...state,
      createSellerLoading,
    };
  }
  case sellerActionTypes.CREATE_SELLER.SUCCESS: {
    const { createdSeller } = action;
    return {
      ...state,
      createdSeller,
    };
  }
  case sellerActionTypes.GET_SELLERS.LOADING: {
    const { getSellersLoading } = action;
    return {
      ...state,
      getSellersLoading,
    };
  }
  case sellerActionTypes.GET_SELLERS.SUCCESS: {
    const { sellers } = action;
    return {
      ...state,
      sellers,
    };
  }

  case sellerActionTypes.SEARCH_SELLERS.LOADING: {
    const { searchSellersNameLoading } = action;
    return {
      ...state,
      searchSellersNameLoading,
    };
  }
  case sellerActionTypes.SEARCH_SELLERS.SUCCESS: {
    const { searchSellersNameResults } = action;
    return {
      ...state,
      searchSellersNameResults,
    };
  }

  case sellerActionTypes.GET_SELLER_OFFERS_BY_ID.LOADING: {
    const { getSellerOffersByIdLoading } = action;
    return {
      ...state,
      getSellerOffersByIdLoading,
    };
  }
  case sellerActionTypes.GET_SELLER_OFFERS_BY_ID.SUCCESS: {
    const { selectedSellerOffers } = action;
    return {
      ...state,
      selectedSellerOffers,
    };
  }
  case sellerActionTypes.GET_SELLER_BY_ID.LOADING: {
    const { getSellerByIdLoading } = action;
    return {
      ...state,
      getSellerByIdLoading,
    };
  }
  case sellerActionTypes.GET_SELLER_BY_ID.SUCCESS: {
    const { selectedSeller } = action;
    return {
      ...state,
      selectedSeller,
    };
  }
  case sellerActionTypes.UPDATE_SELLER.LOADING: {
    const { updateSellerLoading } = action;
    return {
      ...state,
      updateSellerLoading,
    };
  }
  case sellerActionTypes.UPDATE_SELLER.SUCCESS: {
    const { updatedSeller } = action;
    return {
      ...state,
      updatedSeller,
    };
  }
  case sellerActionTypes.UPDATE_SELLER_OFFERS.LOADING: {
    const { updateSellerOffersLoading } = action;
    return {
      ...state,
      updateSellerOffersLoading,
    };
  }
  case sellerActionTypes.UPDATE_SELLER_OFFERS.SUCCESS: {
    const { updatedSellerOffers } = action;
    return {
      ...state,
      updatedSellerOffers,
    };
  }
  case sellerActionTypes.DELETE_SELLER.LOADING: {
    const { deleteSellerLoading } = action;
    return {
      ...state,
      deleteSellerLoading,
    };
  }
  case sellerActionTypes.DELETE_SELLER.SUCCESS: {
    const { deletedSeller } = action;
    return {
      ...state,
      deletedSeller,
    };
  }
  case sellerActionTypes.GET_ORG_SELLERS.LOADING: {
    const { getOrgSellersLoading } = action;
    return {
      ...state,
      getOrgSellersLoading,
    };
  }
  case sellerActionTypes.GET_ORG_SELLERS.SUCCESS: {
    const { orgSellers } = action;
    return {
      ...state,
      orgSellers,
    };
  }
  case sellerActionTypes.GET_SELLER_REPORTS.LOADING: {
    const { getReportsLoading } = action;
    return {
      ...state,
      getReportsLoading,
    };
  }
  case sellerActionTypes.GET_SELLER_DOWNLOAD_REPORTS.LOADING: {
    const { getDownloadReportsLoading } = action;
    return {
      ...state,
      getDownloadReportsLoading,
    };
  }
  case sellerActionTypes.GET_SELLER_REPORTS.SUCCESS: {
    const { reportData } = action;
    return { ...state, accountStatement: reportData };
  }
  case sellerActionTypes.SEND_ACCOUNT_STATEMENT_MAIL.LOADING: {
    const { sendAccountStatementMailLoading } = action;
    return {
      ...state,
      sendAccountStatementMailLoading,
    };
  }
  case sellerActionTypes.LINK_CUSTOMER.LOADING: {
    const { linkCustomerLoading } = action;
    return {
      ...state,
      linkCustomerLoading,
    };
  }
  case sellerActionTypes.GET_BULK_UPLOAD_SELLER_META_DATA.LOADING: {
    const { getBulkUploadSellerMetadataLoading } = action;
    return {
      ...state,
      getBulkUploadSellerMetadataLoading,
    };
  }
  case sellerActionTypes.GET_BULK_UPLOAD_SELLER_META_DATA.SUCCESS: {
    const { bulkUploadSellerMetadata } = action;
    return {
      ...state,
      bulkUploadSellerMetadata,
    };
  }
  case sellerActionTypes.BULK_UPLOAD_SELLER.LOADING: {
    const { bulkUploadSellersLoading } = action;
    return {
      ...state,
      bulkUploadSellersLoading,
    };
  }
  case sellerActionTypes.BULK_UPLOAD_SELLER.SUCCESS: {
    const { bulkUploadResponse } = action;
    return {
      ...state,
      bulkUploadResponse,
    };
  }
  case sellerActionTypes.BULK_UPLOAD_SELLER.ERROR: {
    const { bulkUploadError } = action;
    return {
      ...state,
      bulkUploadError,
    };
  }
  case sellerActionTypes.BULK_UPDATE_SELLER.LOADING: {
    const { bulkUpdateSellersLoading } = action;
    return {
      ...state,
      bulkUpdateSellersLoading,
    };
  }
  case sellerActionTypes.BULK_UPDATE_SELLER.SUCCESS: {
    const { bulkUpdateResponse } = action;
    return {
      ...state,
      bulkUpdateResponse,
    };
  }
  case sellerActionTypes.BULK_UPDATE_SELLER.ERROR: {
    const { bulkUpdateError } = action;
    return {
      ...state,
      bulkUpdateError,
    };
  }
  case sellerActionTypes.GET_TALLY_SELLERS.LOADING: {
    const { getTallySellersLoading } = action;
    return {
      ...state,
      getTallySellersLoading,
    };
  }
  case sellerActionTypes.GET_TALLY_SELLERS.SUCCESS: {
    const { tallySellers } = action;
    return {
      ...state,
      tallySellers,
    };
  }
  default: {
    return state;
  }
  }
};

export default SellerReducer;
